export type UserFunctions = {
    [key in UserFunction]: boolean;
};

export enum UserFunction {
    createMetadataObject = 'CREATE_METADATA_OBJECT',
    publishRights = 'PUBLISH_RIGHTS',
    viewBackendMonitoring = 'VIEW_BACKEND_MONITORING',
    accessManagementModule = 'ACCESS_MANAGEMENT_MODULE',
    adminFilters = 'ADMIN_FILTERS',
    adminOrganisation = 'ADMIN_ORGANISATION',
    adminEditAllOrganisations = 'ADMIN_EDIT_ALL_ORGANISATIONS',
    adminViewAllOrganisations = 'ADMIN_VIEW_ALL_ORGANISATIONS',
    readOrganisations = 'READ_ORGANISATIONS',
    adminUsers = 'ADMIN_USERS',
    adminAllRoles = 'ADMIN_ALL_ROLES',
    adminLinkRoles = 'ADMIN_LINK_ROLES',
    adminZones = 'ADMIN_ZONES',
    adminGroups = 'ADMIN_GROUPS',
    adminExports = 'ADMIN_EXPORTS',
    adminWebsite = 'ADMIN_WEBSITE',
    adminBackendServices = 'ADMIN_BACKEND_SERVICES',
    submitMedia = 'SUBMIT_MEDIA',
    evaluateMedia = 'EVALUATE_MEDIA',
    publishMedia = 'PUBLISH_MEDIA',
    submitThesaurusSuggestions = 'THESAURUS_SUGGESTIONS_SUBMIT',
    evaluateThesaurusSuggestions = 'THESAURUS_SUGGESTIONS_EVALUATE',
    recycleRecords = 'RECYCLE_RECORDS',
    evaluateUserSuggestions = 'USER_SUGGESTIONS_EVALUATE',
    accessImportModule = 'ACCESS_IMPORT_MODULE',
    accessConceptPhase = 'ACCESS_PHASE_CONCEPT',
    accessPublishedPhase = 'ACCESS_PHASE_PUBLISHED',
    accessArchivedPhase = 'ACCESS_PHASE_ARCHIVED',
    viewSystemSetting = 'VIEW_SYSTEM_SETTINGS',
    viewStandardFields = 'VIEW_STANDARD_FIELDS',
    editStandardFields = 'EDIT_STANDARD_FIELDS',
    viewAdvancedFields = 'VIEW_ADVANCED_FIELDS',
    editAdvancedFields = 'EDIT_ADVANCED_FIELDS',
    adminFieldDefinitions = 'ADMIN_FIELD_DEFINITIONS',
    adminProfiles = 'ADMIN_PROFILES',
    adminBatches = 'ADMIN_BATCHES',
    viewReports = 'VIEW_REPORTS',
    manageShares = 'MANAGE_SHARES'
}
